export function getImageSrc(imageName: string): string {
  if (window.location.hostname === 'localhost') {
    return `/assets/${imageName}`;
  }
  return `https://vstatic-prod.apigateway.co/wsp-admin-center-client.9223372035072662598.prod/assets/${imageName}`;
}
